import React, { useState } from "react";

import {
  Paper,
  Typography,
  Grid,
  Button
} from "@material-ui/core";

import FaceIcon from "@material-ui/icons/FaceOutlined";

import classes from "../../css/getCSS";
import * as constants from "../../config/constants";
import pdfPreviewImage from "../../assets/img/pdf_preview.jpg";
import PhotoIcon from "@material-ui/icons/HowToRegOutlined";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css?external";  // eslint-disable-line

const lifestyleInfo = (props) => {
  console.log("lifestyleInfo===props", props);
  const [modalOpen, setModalOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);


  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined"
              onClick={() => props.editProfileSection("lifestyleinfo")}>Edit</Button>
    );
  }

  let idProof = (
    <div align="center" style={{ paddding: "30px" }}>
      <Typography variant="subheading"></Typography>
    </div>
  );

  const handleClose = () => {
    setModalOpen(false)
  }

  const previewImage = (index) => {
    console.log('lifestyleInfo===previewImage');
    console.log('lifestyleInfo===previewImage===index', index);
    setModalOpen(true)
    setImageIndex(index)
    // this.setState({
    //   modalOpen: true,
    //   imageIndex: index,
    // });
  }

  const photosArr = [];
  if (props.profile.report.length > 0) {
    if (props.profile.report[0].file_type === "IMAGE") {
      idProof = props.profile.report.map((photo, index) => {
        const src = constants.BASE_URL + photo.thumbnail;
        photosArr.push(constants.BASE_URL + photo.preview);
        return (
          <Grid item md={3} sm={6} xs={12} key={photo.id} onClick={() => previewImage(index)}>
            <p className={classes.profileCap}>Thalassemia Report</p>
            <img alt={photo.id} src={src} className={classes.profilePhoto} style={{marginTop:'5px'}}/>
          </Grid>
        );
      });
    } else if (props.profile.report[0].file_type === "PDF") {
      idProof = props.profile.report.map((item) => {
        const src = constants.BASE_URL + item.file;
        return (
          <Grid item md={3} sm={6} xs={12} key={item.id} style={{ alignItems: "center" }}>
            <p className={classes.profileCap}>Thalassemia Report</p>
            <a href={src} target="_blank" rel="noopener noreferrer">
              <img alt={item.id} src={pdfPreviewImage} className={classes.profilePhoto} />
            </a>
          </Grid>
        );
      });
    }
  }

  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(" ")}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <FaceIcon className={classes.titleIcon} />
          Lifestyle & Health
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Body Type</p>
            <p className={classes.profileVal}>
              {(props.profile.lifestyleinfo && props.profile.lifestyleinfo.body_type)
                ? props.profile.lifestyleinfo.body_type.label : "-"}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Diet</p>
            <p className={classes.profileVal}>
              {(props.profile.lifestyleinfo && props.profile.lifestyleinfo.diet)
                ? props.profile.lifestyleinfo.diet.label : "-"}
            </p>
            <br />
          </Grid>

          {/*<Grid item md={6} sm={6} xs={12}>*/}
          {/*  <p className={classes.profileCap}>Smoke</p>*/}
          {/*  <p className={classes.profileVal}>*/}
          {/*    {props.profile.lifestyleinfo.smoke*/}
          {/*      ? props.profile.lifestyleinfo.smoke.label : '-'}*/}
          {/*  </p>*/}
          {/*  <br />*/}
          {/*</Grid>*/}
          {/*<Grid item md={6} sm={6} xs={12}>*/}
          {/*  <p className={classes.profileCap}>Drink</p>*/}
          {/*  <p className={classes.profileVal}>*/}
          {/*    {props.profile.lifestyleinfo.drink*/}
          {/*      ? props.profile.lifestyleinfo.drink.label : '-'}*/}
          {/*  </p>*/}
          {/*  <br />*/}
          {/*</Grid>*/}
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Physical Disabilities</p>
            <p className={classes.profileVal}>
              {
                props.profile.lifestyleinfo ? 
                  props.profile.lifestyleinfo.physical_disabilities ?
                   props.profile.lifestyleinfo.physical_disabilities : 
                   "None" : 
                  "-"
              }
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Thalassemia</p>
            <p className={classes.profileVal}>
              {(props.profile.lifestyleinfo && props.profile.lifestyleinfo.thalassemia)
                ? props.profile.lifestyleinfo.thalassemia.label : "-"}
            </p>
            <br />
          </Grid>
          <br />
          {idProof}
        </Grid>
      </Paper>
      {modalOpen && props.profile.report && props.profile.report[0].file_type === "IMAGE" && (
        <Lightbox
          mainSrc={photosArr[imageIndex]}
          nextSrc={photosArr[(imageIndex + 1) % photosArr.length]}
          prevSrc={photosArr[(imageIndex + photosArr.length - 1) % photosArr.length]}
          onCloseRequest={() => setModalOpen(false)}
          onMovePrevRequest={() => setImageIndex((imageIndex + photosArr.length - 1) % photosArr.length)}
          onMoveNextRequest={() => setImageIndex((imageIndex + 1) % photosArr.length)}
        />
      )}
    </React.Fragment>
  );
};


export default lifestyleInfo;



// WEBPACK FOOTER //
// ./src/profile/components/LifestyleInfo.js